var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { registerSystem, DEPTHS } from "../ComponentRegistry.js";
import "../types.js";
import { P as ParentSchema } from "../../Parent-b4f1af10.js";
import { C as ChildSchema } from "../../Child-888ef1d8.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
import "../../utils/vector.js";
class ChildSystem {
  constructor() {
    __publicField(this, "type", "Child");
    __publicField(this, "category", ComponentCategory.BEHAVIOR);
    __publicField(this, "schema", ChildSchema);
    __publicField(this, "depth", DEPTHS.LOCOMOTION + 10);
    __publicField(this, "dependencies", ["Owner", "Transform", "Locomotion"]);
  }
  init(entity, gameModel) {
    var _a;
    const childData = gameModel.getTypedUnsafe(entity, ChildSchema);
    if (childData.parent == void 0 && gameModel.hasComponent(entity, "Owner")) {
      const ownerData = gameModel.getComponentUnsafe(entity, "Owner");
      if (ownerData.owner != void 0) {
        childData.parent = ownerData.owner;
      }
    }
    if (childData.parent) {
      if (!gameModel.hasComponent(childData.parent, "Parent")) {
        gameModel.addComponent(childData.parent, "Parent", {
          children: [entity]
        });
      } else {
        const parentData = gameModel.getTypedUnsafe(childData.parent, ParentSchema);
        if (parentData.children.indexOf(entity) == -1) {
          parentData.children.push(entity);
        }
      }
      const modIds = gameModel.getComponentIdsByCategory(childData.parent, ComponentCategory.ON_ADD_TO_PARENT);
      for (let i = 0; i < modIds.length; i++) {
        const mod = gameModel.getComponent(childData.parent, modIds[i]);
        if (mod.parent !== void 0) {
          mod.parent = childData.parent;
        }
        if (mod.child !== void 0) {
          mod.child = entity;
        }
        const system = gameModel.getSystem(modIds[i]);
        (_a = system.run) == null ? void 0 : _a.call(system, childData.parent, gameModel);
      }
      if (childData.autoAttach) {
        const { autoAttach, ...attachData } = childData;
        gameModel.addComponent(entity, "Attach", {
          ...attachData
        });
      }
    }
  }
  run(entity, gameModel) {
    var _a;
    let modIds;
    const childData = gameModel.getTypedUnsafe(entity, ChildSchema);
    if (childData.parent != void 0) {
      if (!gameModel.isActive(childData.parent)) {
        childData.parent = null;
        return;
      }
      let checkAttach = false;
      if (!gameModel.hasComponent(childData.parent, "Parent")) {
        gameModel.addComponent(childData.parent, "Parent", {
          children: [entity]
        });
        checkAttach = true;
      } else {
        const parentData = gameModel.getTypedUnsafe(childData.parent, ParentSchema);
        if (parentData.children.indexOf(entity) == -1) {
          parentData.children.push(entity);
          checkAttach = true;
        }
      }
      if (checkAttach) {
        modIds = (modIds == null ? void 0 : modIds.length) ? modIds : gameModel.getComponentIdsByCategory(childData.parent, ComponentCategory.ON_ADD_TO_PARENT);
        for (let i = 0; i < modIds.length; i++) {
          const mod = gameModel.getComponent(childData.parent, modIds[i]);
          if (mod.parent !== void 0) {
            mod.parent = childData.parent;
          }
          if (mod.child !== void 0) {
            mod.child = entity;
          }
          const system = gameModel.getSystem(modIds[i]);
          (_a = system.run) == null ? void 0 : _a.call(system, childData.parent, gameModel);
        }
      }
      if (checkAttach && childData.autoAttach) {
        const { autoAttach, ...attachData } = childData;
        gameModel.addComponent(entity, "Attach", {
          ...attachData
        });
      }
    }
  }
}
registerSystem(ChildSystem);
//# sourceMappingURL=Child.js.map
